const SAMPLE_SIZE = 8192;
const MAX_REPLACEMENT_RATIO = 0.05;

// Null bytes are ubiquitous in binary formats but absent from text encodings,
// so their presence in the leading sample is a reliable binary signal.
export function isProbablyText(bytes: Uint8Array | null | undefined): boolean {
  if (!bytes || bytes.length === 0) return false;

  const sample = bytes.subarray(0, SAMPLE_SIZE);
  if (sample.includes(0)) return false;

  const decoded = new TextDecoder("utf-8", { fatal: false }).decode(sample);
  const replacementCount = [...decoded].filter((char) => char === "�").length;
  return replacementCount / decoded.length <= MAX_REPLACEMENT_RATIO;
}
